import { createClient } from '@supabase/supabase-js'

// Production by default. For a local sandbox, set VUE_APP_SUPABASE_URL / VUE_APP_SUPABASE_ANON_KEY in
// .env.development.local (gitignored, only loaded by `npm run serve`) — production builds ignore it.
const PRODUCTION_URL = "https://vosqqgykjafrywdcpsfz.supabase.co";
const PRODUCTION_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZvc3FxZ3lramFmcnl3ZGNwc2Z6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDMwNDMzMzEsImV4cCI6MjAxODYxOTMzMX0.drlu7fXvFicVbWoyS6ZHYWqx-6BntPShoDkErPGNGZM";

export const SupabaseClient = createClient(
    process.env.VUE_APP_SUPABASE_URL || PRODUCTION_URL,
    process.env.VUE_APP_SUPABASE_ANON_KEY || PRODUCTION_ANON_KEY
);

/*
API URL: http://127.0.0.1:54321
    GraphQL URL: http://127.0.0.1:54321/graphql/v1
    DB URL: postgresql://postgres:postgres@127.0.0.1:54322/postgres
    Studio URL: http://127.0.0.1:54323
    Inbucket URL: http://127.0.0.1:54324
    JWT secret: super-secret-jwt-token-with-at-least-32-characters-long
    anon key: eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZS1kZW1vIiwicm9sZSI6ImFub24iLCJleHAiOjE5ODM4MTI5OTZ9.CRXP1A7WOeoJeXxjNni43kdQwgnWNReilDMblYTn_I0
service_role key: eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZS1kZW1vIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImV4cCI6MTk4MzgxMjk5Nn0.EGIM96RAZx35lJzdJsyH-qQwv8Hdp7fsn3W0YpN81IU
*/
